import { configureStore } from '@reduxjs/toolkit';
//import logger from 'redux-logger'
import logReducer from './log';

const store = configureStore({
    reducer: {
        log: logReducer
    },
    //middleware: (getDefaultMiddleware) => {
    //    return getDefaultMiddleware().concat(logger);
    //},
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store;